/**
 * Loads the cart drawer's promoted product cards on demand instead of in every page's HTML.
 * Fills every [data-promo-lazy] container (desktop + mobile) from sections/cart-promoted-products.liquid,
 * either when the browser is idle after load or when the cart drawer is first shown, whichever comes first.
 */
(() => {
  const containers = () => document.querySelectorAll('[data-promo-lazy]:empty');
  let loading = null;

  const load = () => {
    if (loading || !containers().length) return loading;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    loading = fetch(`${root}?section_id=cart-promoted-products`)
      .then((res) => (res.ok ? res.text() : Promise.reject(res.status)))
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const list = doc.querySelector('.product-container');
        if (!list) return;
        containers().forEach((el) => { el.innerHTML = list.innerHTML; });
      })
      .catch(() => { loading = null; });
    return loading;
  };

  const drawer = document.getElementById('drawer-cart');
  if (drawer) {
    new MutationObserver((_, obs) => {
      if (drawer.style.display !== 'none') { load(); obs.disconnect(); }
    }).observe(drawer, { attributes: true, attributeFilter: ['style', 'class'] });
  }

  const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 2000));
  window.addEventListener('load', () => idle(load, { timeout: 5000 }), { once: true });
})();
